import script from "./SegmentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentsView.vue?vue&type=script&setup=true&lang=js"

import "./SegmentsView.vue?vue&type=style&index=0&id=aa280572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa280572"]])

export default __exports__